import React from 'react';

const AdminPageTemplate = ({ children }) => // to do refactore style
	 (
  <div style={{ width: '100%' }}>
    {children}
  </div>
  );
export default AdminPageTemplate;
